import { IExcCategory } from 'onboarding/components/widgets/public/admin/exceptionsReasons/models'

interface IProps {
  categories: IExcCategory[]
  keyField: string
  relationField: string
}

export type TMarkedCategory = IExcCategory & { HasChildren?: boolean }

export const markCategoriesHierarchy = ({
  categories,
  keyField,
  relationField,
}: IProps): TMarkedCategory[] => {
  const parentMap: Record<string, boolean | undefined> = {}
  categories.forEach((el) => {
    if (el[relationField]) {
      parentMap[el[relationField]] = true
    }
  })

  return categories.map((el) => {
    const newTopic: TMarkedCategory = { ...el }
    if (el[relationField]) {
      newTopic[relationField] = el[relationField] || ''
    }
    if (parentMap[el[keyField]]) {
      newTopic.HasChildren = true
    }

    return newTopic
  })
}
